import { useEventEmitter, useMutation } from 'common/hooks';
import { UseMutationOptions } from 'common/types/Api.type';
import { createCompanyUpdateApi } from '../company-updates.service';
import { CompanyUpdateEventData } from '../types';

export const useCreateCompanyUpdate = (options: UseMutationOptions = {}) => {
  const { emitWithSettledAfter } =
    useEventEmitter<CompanyUpdateEventData>('CompanyUpdateAdded');

  return useMutation(createCompanyUpdateApi, {
    showSuccessSnackbar: true,
    onSuccess: () => {
      emitWithSettledAfter(5000);
    },
    ...options,
  });
};
